<template>
  <div class="el-header">
    <div class="el-header-top">
      <ul class="el-ul-left">
        <li
          :class="$route.path.indexOf(item.path) >= 0 ? 'active' : ''"
          v-for="(item, index) in routerList.slice(0, 5)"
          :key="index"
          @click="$router.push(item.path)"
        >
          <span class="el_span">{{ item.meta.title }}</span>
        </li>
      </ul>
      <div class="logo">
        {{ getPageTitle }}
      </div>
      <ul class="el-ul-right">
        <li
          :class="$route.path.indexOf(item.path) >= 0 ? 'active' : ''"
          v-for="(item, index) in routerList.slice(6)"
          :key="index"
          @click="$router.push(item.path)"
        >
          <span class="el_span">{{ item.meta.title }}</span>
        </li>
      </ul>
    </div>
    <div class="el-below">
      <div class="left_a1">
        <div class="left_s1">
          {{ gettime }}
          <span style="margin-left: 20px">{{ weatherData.tem }}°C</span>
          <img class="img" :src="handelReckon(weatherData.wea_img)" alt="" />
        </div>
      </div>
      <div class="right_a1">
        <div class="right_s1">
          <div @click="screen">
            <img src="@/assets/header_images/quanping.png" alt="" />
            <span>{{ fullscreen ? '退出全屏' : '全屏' }}</span>
          </div>
          <div style="margin-left: 30px" @click="goOut">
            <img src="@/assets/header_images/guanbi.png" alt="" />
            <span>退出</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { asyncRoutes } from '@/router'
  import { title } from '@/config'
  import axios from 'axios'
  export default {
    data() {
      return {
        activeIndex: '1',
        routerList: [],
        getPageTitle: title,
        gettime: '',
        weatherData: {},
        fullscreen: false,
      }
    },

    created() {
      let list = [...asyncRoutes]
      this.routerList = list[0].children
    },
    mounted() {
      this.handelCartoon()
      this.getCurrentTime()
      this.getWeather()
      //监听键盘事件
      window.addEventListener('keydown', this.KeyDown, true) // 监听按键事件
      //监听全屏
      document.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement) {
          console.log(
            `Element: ${document.fullscreenElement.id} entered full-screen mode.`
          )
        } else {
          this.fullscreen = false
        }
      })
    },

    methods: {
      //f11键盘事件，阻止F11
      KeyDown(event) {
        if (event.keyCode === 122) {
          event.returnValue = false
        }
      },
      goOut() {
        // localStorage.clear()
        // this.$router.push('/login')
        this.$confirm('确定退出该平台吗？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$store.dispatch('user/logout')
        })
      },
      //全屏
      screen() {
        let element = document.documentElement
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen()
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen()
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen()
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen()
          }
        }
        this.fullscreen = !this.fullscreen
      },
      handelCartoon() {
        this.$animejs({
          targets: '.el-below',
          translateY: [-200, 0],
          duration: 2000,
          delay: 100,
          skewX: [160, 0],
          easing: 'easeInOutExpo',
        })
      },
      //时间
      getCurrentTime() {
        var _this = this
        let yy = new Date().getFullYear() //年
        let mm =
          new Date().getMonth() + 1 < 10
            ? '0' + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1 //月
        let dd =
          new Date().getDate() < 10
            ? '0' + new Date().getDate()
            : new Date().getDate() //日
        let hh =
          new Date().getHours() < 10
            ? '0' + new Date().getHours()
            : new Date().getHours() //时
        let mf =
          new Date().getMinutes() < 10
            ? '0' + new Date().getMinutes()
            : new Date().getMinutes() //分
        let ss =
          new Date().getSeconds() < 10
            ? '0' + new Date().getSeconds()
            : new Date().getSeconds() //秒
        _this.gettime =
          yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
        setTimeout(() => {
          this.getCurrentTime()
        }, 1000)
      },
      //获取天气数据
      getWeather() {
        axios
          .get('https://www.yiketianqi.com/free/day', {
            params: { appid: '86353798', appsecret: '7qisahTg', city: '成都' },
          })
          .then((res) => {
            if (res.status === 200) {
              this.weatherData = res.data
            }
          })
      },
      //天气对应图片
      handelReckon(i) {
        var img = ''
        switch (i) {
          case 'xue':
            img = require('@/assets/header_images/baoxue.png')
            break
          case 'lei':
            img = require('@/assets/header_images/lbtq.png')
            break
          case 'yun':
            img = require('@/assets/header_images/duoyun.png')
            break
          case 'qing':
            img = require('@/assets/header_images/qing.png')
            break
          case 'yin':
            img = require('@/assets/header_images/duoyunzhuanqing.png')
            break
          case 'yu':
            img = require('@/assets/header_images/xiaoyu.png')
            break
          case 'bingbao':
            img = require('@/assets/header_images/baoxue.png')
            break
          case 'wu':
            img = require('@/assets/header_images/wumai.png')
            break
          default:
            img = require('@/assets/header_images/duoyun.png')
            break
        }
        return img
      },
    },
  }
</script>
<style lang="scss" scoped>
  @mixin heaer-style($a) {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    background: linear-gradient(#23403a, #25433c);
    border: 1px solid #324d48;
    height: 50px;
    white-space: nowrap;
    width: 19vw;
    transform: skewX($a);
    margin-right: 3px;
  }
  .el-header {
    position: relative;
    z-index: 999;
    .el-header-top {
      display: flex;
      align-items: center;
      height: 68px;
      background: #000;
    }
    .el-ul-left {
      display: flex;
      list-style: none;
      line-height: 50px;
      width: 31vw;
      position: relative;
      left: 28px;

      li {
        @include heaer-style(34deg);
        .el_span {
          transform: skewX(-34deg);
          display: inline-block;
        }
      }
      li.active {
        background: linear-gradient(#d2890e, #d8b21e);
      }
    }
    .el-ul-right {
      display: flex;
      list-style: none;
      line-height: 50px;
      width: 31vw;
      position: relative;
      right: 24px;
      li {
        @include heaer-style(-34deg);
        .el_span {
          transform: skewX(34deg);
          display: inline-block;
        }
      }

      .active {
        background: linear-gradient(#d2890e, #d8b21e);
        transition: all 120s cubic-bezier(1, 0.5, 0.8, 1);
      }
    }

    .el-below {
      display: flex;
      justify-content: space-between;
      .left_a1 {
        background: #000;
        height: 40px;
        line-height: 30px;
        width: 21vw;
        transform: skewX(-45deg);
        position: relative;
        right: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .left_s1 {
          transform: skewX(45deg);
          color: #ffffff;
          font-size: 16px;
          position: relative;
          bottom: 8px;
          .img {
            position: relative;
            top: 7px;
            left: 5px;
          }
        }
      }
      .right_a1 {
        background: #000;
        height: 40px;
        width: 21vw;
        transform: skewX(45deg);
        position: relative;
        cursor: pointer;
        left: 30px;
        .right_s1 {
          transform: skewX(-45deg);
          display: flex;
          align-items: center;
          justify-content: right;
          margin-right: 68px;
          div {
            display: flex;
            align-items: center;
            color: #fff;
            span {
              position: relative;
              top: -1px;
            }
          }
        }
      }
    }
  }

  @mixin text-style($c) {
    color: #fff;
    cursor: pointer;
    line-height: 90px;
    text-align: $c;
  } // logo
  .logo {
    @include text-style(center);
    font-size: 40px;
    font-weight: 600;
    height: 90px;
    white-space: nowrap;
    width: 38vw;
    overflow: hidden;
    text-overflow: ellipsis;
    background: url('../../../assets/header_images/chang.png') no-repeat top;
    background-size: 100% 100%;
    width: 100%;
    letter-spacing: 10px;
  }

  // 退出
  .loginOut {
    @include text-style(right);
  }
</style>
